import { render, staticRenderFns } from "./MarcaVeiculoFilterBar.vue?vue&type=template&id=5b914868"
import script from "./MarcaVeiculoFilterBar.vue?vue&type=script&lang=js"
export * from "./MarcaVeiculoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports